import { toast } from "react-toastify";

 // Add validation for mobile
 const validateMobile = (mobile) => {
    // Remove any non-digit characters and country code if present
    const cleanNumber = mobile.toString().replace(/\D/g, '');
    
    // If number starts with country code (e.g., 91 for India), remove it
    const numberWithoutCountry = cleanNumber.startsWith('91') 
      ? cleanNumber.slice(2) 
      : cleanNumber;
    
    // console.log("Cleaned mobile number:", numberWithoutCountry);
    
    // Check if the remaining number is valid (10 digits for India)
    return numberWithoutCountry && numberWithoutCountry.length >= 10;
  };

export const validateProfile = (values) => {
    const { firstName, lastName, mobile, email, countryCode } = values;
    const toastId = "profile-form";
    
    if (!firstName || !firstName.trim()) {
      if (!toast.isActive(toastId)) {
          toast.error("Please Enter your first name", { toastId: toastId });
      }
      return false;
    }
    if (!lastName || !lastName.trim()) {
      if (!toast.isActive(toastId)) {
        toast.error("Please Enter your last name", { toastId: toastId });
      }
      return false; 
    }
    
    // Enhanced mobile validation
    if (!mobile || !validateMobile(mobile)) {
        toast.error("Please enter a valid mobile number (minimum 10 digits)", { toastId: toastId });
      return false;
    }

    if (!email || !email?.trim()) {
      if (!toast.isActive(toastId)) {
        toast.error("Please Enter Your Email", { toastId: toastId });
      }
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please Enter Valid Email Address");
      return false;
    }
    return true;
  };


  export const UpdateProfile = async (values, userId) => {
    const updateData = {
      firstName: values.firstName.trim(),
      lastName: values.lastName.trim(),
      mobile: values.mobile,
      email: values.email,
      countryCode: values.countryCode,
    };

    const formData = new FormData();
    formData.append("firstName", updateData.firstName);
    formData.append("lastName", updateData.lastName);
    formData.append("mobile", updateData.mobile);
    formData.append("email", updateData.email);
    formData.append("countryCode", updateData.countryCode);
    formData.append("userId", userId);

    if (validateProfile(values)) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL}/api/users/update-profile`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
            body: formData,
          }
        );
        const data = await response.json();

        if (data.success) {
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        // console.log("profile update error ", error);
        toast.error("Failed to update profile");
      }
    }
  }
